export default __webpack_public_path__ + "static/media/templates_card.6736a85f.jpg";